import { NavLayout } from '@layouts/NavLayout';
import { UserProfileContainer } from '@containers/UserProfile';
import { ProfileTabsContainer } from '@containers/ProfileTabs';
import { LayoutContainer } from '@ui/LayoutContainer';

import s from './ProfileLayout.sss';

type Props = {
  username: string,
};

export const ProfileLayout: React.FC<React.PropsWithChildren<Props>> = ({
  username,
  children,
}) => (
  <NavLayout
    className={s.pageContent}
    withLayoutContainer={false}
  >
    <div className={s.profileBackground}>
      <LayoutContainer>
        <UserProfileContainer username={username} className={s.profileBlock} />
      </LayoutContainer>
    </div>

    <div className={s.tabsOuter}>
      <LayoutContainer>
        <ProfileTabsContainer username={username} />
      </LayoutContainer>
    </div>

    <LayoutContainer className={s.contentLayout}>
      {children}
    </LayoutContainer>
  </NavLayout>
);
